import ATable from './ATable';
import ATradeTable from './ATradeTable';
import ACustomerSelector from './ACustomerSelector';
import AProductSelector from './AProductSelector';
// import AProductAmountInput from "./AProductAmountInput";
// import AProductCost from "./AProductCost";
import APeriodSelector from './APeriodSelector';
import AUserSelector  from './AUserSelector';
// import AProcessSelector from './AProcessSelector';
// import ATaskSelector from './ATaskSelector';
import ADeliveryWaySelector from './ADeliveryWaySelector';
import ANumberKey from './ANumberKey';
import ANumberInput from './ANumberInput'
import AProductTypeSelector from './AProductTypeSelector'
import AProductTypeTreeSelector from './AProductTypeTreeSelector'
import ABomTree from './ABomTree'
import ABomTable from './ABomTable'
import ACheckboxYN from './ACheckboxYN'
import AProductUnitSelector from './AProductUnitSelector'
import AHelper from './AHelper'
import ANumberSelector from './ANumberSelector'
import ASelector from './ASelector'
import ADatePicker from './ADatePicker'
import ARadioGroup from './ARadioGroup'
import AMonthSelector from './AMonthSelector'

const components = [
  ATable,
  ATradeTable,
  ACustomerSelector,
  AProductSelector,
  // AProductAmountInput,
  // AProductCost,
  APeriodSelector,
  AUserSelector,
  // AProcessSelector,
  // ATaskSelector,
  ADeliveryWaySelector,
  ANumberKey,
  ANumberInput,
  AProductTypeSelector,
  AProductTypeTreeSelector,
  ABomTree,
  ABomTable,
  ACheckboxYN,
  AProductUnitSelector,
  AHelper,
  ANumberSelector,
  ASelector,
  ADatePicker,
  ARadioGroup,
  AMonthSelector,
]

const install = function (Vue) {
  components.map(component => {
    Vue.component(component.name, component)
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install
}